import appStore from 'store';
import api from './api';
import { STATUS_TYPES } from './constants';
import LANGUAGE from 'common/languages';

const store = {
  namespaced: true,
  state: {
    StaffSumLists: [],
    projects: [],
    coinTypeList: [],
    oneday: [],
    totalCount: 0,
    totalCounts: 0,
    editingProject: null,
    pagination: {
      page: 1,
      size: 25
    },
    languageList: Object.keys(LANGUAGE).map(item => {
      return {
        value: item.toString(),
        label: LANGUAGE[item]
      };
    })
  },
  getters: {
    projectList: state =>
      state.projects.map(item => ({
        ...item,
        __status: STATUS_TYPES[item.status]
      }))
  },
  mutations: {
    setList(state, payload) {
      state.projects = payload.list;
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setCoinTypeList(state, payload) {
      state.coinTypeList = payload;
    },
    setEditingProject(state, payload) {
      state.editingProject = payload;
    },
    StaffSumList(state, payload) {
      state.StaffSumLists = payload;
    },
    getOneday(state, payload) {
      state.oneday = payload;
      state.totalCounts = payload.totalCount;
    }
  },
  actions: {
    getList({ commit }, query) {
      api.getList(query).then(({ data }) => {
        commit('setList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    add(context, data) {
      return api.add(data);
    },
    update(context, data) {
      return api.update(data);
    },
    getCoinTypeList({ commit }) {
      api.getCoinTypeList().then(({ data }) => {
        commit('setCoinTypeList', data);
      });
    },
    createRules(context, content) {
      return new Promise(resolve => {
        api.createRulescontent(content).then(res => {
          resolve(res);
        });
      });
    },
    getRules(context, data) {
      return api.getRules(data);
    },
    setBaseAmount(context, content) {
      return new Promise(resolve => {
        api.setBaseConfig(content).then(res => {
          resolve(res);
        });
      });
    },
    getBaseAmount(context, data) {
      return api.getBaseAmount(data);
    },
    freshData(content, data) {
      return api.freshFoundationRes(data);
    },
    setPercent(content, data) {
      return api.setpercent(data);
    },
    getpercent(content, data) {
      return api.getpercent(data);
    },
    searchAmount(content, data) {
      return api.searchAmount(data);
    },

    getStaffSumList({ commit }, data) {
      return api.getStaffSumList(data).then(({ data }) => {
        commit('StaffSumList', data);
      });
    },
    getIdamount({ commit }, data) {
      return api.getIdamount(data).then(({ data }) => {
        commit('getOneday', data);
      });
    }
  }
};

appStore.registerModule('kpiProject', store);
